import { FileExtended } from 'shell/view-models/edit-data-control-person';

export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('loadend', (e) => {
      if (e.target && typeof e.target.result === 'string') {
        resolve(btoa(e.target.result));
      } else {
        reject('Something went wrong');
      }
    });
    reader.addEventListener('error', reject);
    reader.readAsBinaryString(file);
  });
};

export const readFileAsDataUrlBase64 = (file: File): Promise<FileExtended> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      const { result } = event.target || {};

      if (result) {
        resolve({
          ...file,
          name: file.name,
          size: file.size,
          type: file.type,
          raw: (result as string).split(',')[1],
        });
      } else {
        reject('error in upload file');
      }
    });

    reader.readAsDataURL(file);
  });
};
